import { PHI_CMS_LAYOUT_PLUGIN_KEYS } from "./cms-layout-type-keys";
import { PhiCmsWidgetType } from "./cms-widget-types";

export const PhiRuntimeRenderClientType = {
  AuthLogout: "@phis/ui/modules/auth/controller/default#logout",
  AuthMethods: "@phis/ui/modules/auth/controller/default#methods",
  AuthSecurity: "@phis/ui/modules/auth/controller/default#security",
  AuthWorkflow: "@phis/ui/modules/auth/controller/default#workflow",
  AccountPreview: `${PhiCmsWidgetType.Account}#preview`,
  BuilderModeSwitch: `${PhiCmsWidgetType.Switch}#builder-mode`,
  SearchStandalone: "@phis/ui/controls/search",
  SidebarNavigationPreview: `${PhiCmsWidgetType.SidebarNavigation}#preview`,
  BaseLayout: `${PHI_CMS_LAYOUT_PLUGIN_KEYS.core}/base#client`,
  RegionContainerEnhancer: "@phis/ui/runtime#region-container",
  OverlayContainer: "@phis/ui/runtime#overlay-container",
  SlotChildFrameEnhancer: "@phis/ui/runtime#slot-child-frame",
  FormDescriptor: "@phis/ui/form#descriptor",
  FormWidgetFrame: "@phis/ui/form#widget-frame",
} as const;
